import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Permission } from '../models/Permission'
import { PERMISSIONS_URL } from '../utils/urls'

const fetchPermissions = (params: TableParams) =>
  SBAPI.FetchPaginated<Permission[]>(PERMISSIONS_URL, params)

const fetchPermissionById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Permission>(`${PERMISSIONS_URL}/${id}`, params)

const createPermission = (permission: Permission) =>
  SBAPI.Post(PERMISSIONS_URL, permission)

const updatePermission = (permission: Permission) =>
  SBAPI.Put(`${PERMISSIONS_URL}/${permission.id}`, permission)

const deletePermission = (permission: Permission) =>
  SBAPI.Delete(`${PERMISSIONS_URL}/${permission.id}`)

export {
  createPermission,
  deletePermission,
  fetchPermissionById,
  fetchPermissions,
  updatePermission,
}
